<template>
  <span v-bind:class="channelClasses" v-tippy></span>
  <tippy>{{asText}}</tippy>
</template>


<script>

export default {
  name: 'ChannelIcon',
  props: ['channelType', 'customer', 'select', 'internal', 'resolved', 'suffixText', 'reopened', 'inactive'],
  computed: {
    channelClasses() {
      let classes = '';
      if (this.internal) {
        classes += ' internal-message bg-yellow-500';
      } else if (this.resolved) {
        classes += ' resolve-message bg-emerald-500';
      } else if (this.reopened) {
      classes += ' reopened-message bg-sky-500';
      } else {
        classes += ` ${this.channelType}`;
        if (this.inactive) {
          classes += ' bg-gray-500';
        } else {
          if (this.channelType === 'messenger') {
            classes += ' bg-blue-500';
          }
          if (this.channelType === 'whatsapp') {
            classes += ' bg-green-500';
          }
          if (this.channelType === 'instagram') {
            classes += ' bg-rose-600';
          }
        }
      }
      if (this.customer) {
        classes += ' customer-channel-icon';
      }
      if (this.select) {
        classes += ' select-icon';
      } else {
        classes += ' channel-icon';
      }
      return classes;
    },
    asText() {
      if (this.internal) {
        return this.$t('conversation.internalNote');
      }
      let text;
      if (this.channelType === 'messenger') {
        text = 'Facebook Messenger';
      }
      else if (this.channelType === 'whatsapp') {
        text = 'WhatsApp';
      }
      else if (this.channelType === 'instagram') {
        text = 'Instagram';
      }
      else {
        text = this.channelType;
      }
      if (this.suffixText) {
        text += ` [${this.suffixText}]`;
      }
      return text;
    }
  },
}
</script>
